import firebase from 'firebase';

const config = firebase.initializeApp({
    apiKey: "AIzaSyA4tjwsy5OChdiQdAKLLbhHtIxORxILDsw",
    authDomain: "bhangraintheburgh16.firebaseapp.com",
    projectId: "bhangraintheburgh16",
    storageBucket: "bhangraintheburgh16.appspot.com",
    messagingSenderId: "842288922414",
    appId: "1:842288922414:web:f95184c58a73aa739944bf",
    measurementId: "G-PNNC9E0L46"
  });
  
const db=firebase.firestore();

export {db}
export default !firebase.apps.length ? firebase.initializeApp(config) : firebase.app();